import React from 'react'
import contactIcon from '../images/contact_icon.png'
interface Props {
  groupName?: string
  avatarUrl?: string
  color?: string
  onConsult?: () => void
  className?: string
  /** 自定义弹窗标题 · 与 subtitle 同时有效才替换团队名；否则现状 */
  title?: React.ReactNode
  /** 自定义副标题 · 与 title 同时有效才替换「一人付费…」 */
  subtitle?: React.ReactNode
}

const Header: React.FC<Props> = ({
  groupName,
  avatarUrl,
  color,
  onConsult,
  className,
  title,
  subtitle
}) => {
  // 标题副标题都有效才整体替换；缺一个就保持现状（头像始终保留）
  const useCustom = !!(title && subtitle)
  return (
    <div className={`vip-header ${className || ''}`}>
      <div className="vip-header-left">
        {groupName && !avatarUrl && (
          <div className="vip-avatar" style={{ backgroundColor: color }}>
            {groupName.substr(0, 2)}
          </div>
        )}
        {avatarUrl && (
          <div
            className="vip-avatar"
            style={{
              backgroundImage: avatarUrl ? `url(${avatarUrl})` : undefined,
              backgroundSize: 'cover'
            }}
          />
        )}
        <div className="vip-meta">
          <div className="vip-title">
            {useCustom ? title : groupName || '团队名称'}
          </div>
          <div className="vip-sub">
            {useCustom ? subtitle : '一人付费，全部成员共享权益'}
          </div>
        </div>
      </div>
      <div className="vip-header-right">
        <img src={contactIcon} alt="购买咨询" className="contact-icon" />
        <span className="consult-text" onClick={onConsult}>
          购买咨询
        </span>
      </div>
    </div>
  )
}

export default Header
